import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PlantingSiteDto } from '../../../models/trofaco/plantingSiteDto';
import { SiteListAccessService } from './site-list-access.service';

@Component({
    selector: 'app-planting-site-list',
    templateUrl: './planting-site-list.component.html',
    styleUrls: ['./planting-site-list.component.css'],
    providers: [SiteListAccessService]
})
export class PlantingSiteListComponent implements OnInit {
    sites: PlantingSiteDto[];

    constructor(private route: ActivatedRoute, private siteAccess: SiteListAccessService) {
    }

    ngOnInit() {
        this.route.data.subscribe(data => {
            this.sites = data.plantingSites;
        });
    }

    sitesUpdated(sites: PlantingSiteDto[]) {
        this.siteAccess.updateFilteredSites(sites);
    }

}
